import { _t } from "app/i18n/i18n";
import { toLocaleYYYYMMDD } from "lib/dateUtils";

export const isStandardDate = (date) => ["1 Week", "1 Month", "6 Months", "1 Year"].includes(date);

export const formatPillDate = (text, category) => {
  let newText = "";
  if (isStandardDate(text)) text = _t(text);
  if (text.includes("Range")) newText = formatRange(text);
  else if (category === "Date") newText = _t("From date") + " " + text;
  else if (category === "DateTo") newText = _t("To date") + " " + text;
  return newText;
};

function formatRange(strDateRange) {
  let [, strFrom, strTo] = strDateRange.split("|");
  let dateFrom = new Date(parseInt(strFrom));
  let dateTo = new Date(parseInt(strTo));
  return _t("From date") + " " + toLocaleYYYYMMDD(dateFrom) + " " + _t("To date") + " " + toLocaleYYYYMMDD(dateTo);
}

export const isDateCategory = (category) => category === "Date" || category === "DateTo";
